export default "__VITE_ASSET__Bp4yOJdG__"